import React from "react";
import { Phone, Mail, MapPin } from "lucide-react";
import { siteConfig } from "../siteConfig";
import QuoteFormEmbed from "../components/QuoteFormEmbed";
import Reveal from "../components/Reveal";

const ContactPage = () => (
  <>
    <section
      className="relative flex items-end"
      style={{
        minHeight: "38vh",
        backgroundImage: `url(${siteConfig.hero.image})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="absolute inset-0" style={{ background: "linear-gradient(to top, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.45) 100%)" }} />
      <div className="relative z-10 w-full max-w-7xl mx-auto px-5 md:px-8 pb-12 pt-32">
        <p className="text-xs font-black uppercase tracking-widest mb-3" style={{ color: siteConfig.colors.primary }}>
          Get In Touch
        </p>
        <h1 className="font-display font-black text-white leading-tight mb-3" style={{ fontSize: "clamp(2.2rem,5vw,3.75rem)" }}>
          Contact Us
        </h1>
        <p className="text-white/70 text-lg max-w-2xl">
          Ready to get started? Reach out for a free, no-obligation estimate.
        </p>
      </div>
    </section>

    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-6xl mx-auto px-5 md:px-8 grid lg:grid-cols-2 gap-12">
        {/* Info */}
        <Reveal as="div">
          <h2 className="font-display font-black text-2xl mb-6" style={{ color: siteConfig.colors.dark }}>
            Let's talk about your project
          </h2>
          <p className="text-gray-600 leading-relaxed mb-8">
            Whether you have a fully formed vision or just a rough idea, our team is happy to walk you through the options. We serve {siteConfig.city}, {siteConfig.state} and surrounding areas.
          </p>

          <div className="space-y-5">
            <a href={siteConfig.phoneHref} className="flex items-center gap-4 group">
              <div
                className="w-12 h-12 rounded-xl flex items-center justify-center"
                style={{ backgroundColor: `${siteConfig.colors.primary}15` }}
              >
                <Phone className="w-5 h-5" style={{ color: siteConfig.colors.primary }} />
              </div>
              <div>
                <div className="text-xs text-gray-500 font-medium uppercase tracking-wide mb-0.5">Phone</div>
                <div className="font-bold text-sm group-hover:underline" style={{ color: siteConfig.colors.dark }}>{siteConfig.phone}</div>
              </div>
            </a>

            <a href={`mailto:${siteConfig.email}`} className="flex items-center gap-4 group">
              <div
                className="w-12 h-12 rounded-xl flex items-center justify-center"
                style={{ backgroundColor: `${siteConfig.colors.primary}15` }}
              >
                <Mail className="w-5 h-5" style={{ color: siteConfig.colors.primary }} />
              </div>
              <div>
                <div className="text-xs text-gray-500 font-medium uppercase tracking-wide mb-0.5">Email</div>
                <div className="font-bold text-sm group-hover:underline" style={{ color: siteConfig.colors.dark }}>{siteConfig.email}</div>
              </div>
            </a>

            <div className="flex items-center gap-4">
              <div
                className="w-12 h-12 rounded-xl flex items-center justify-center"
                style={{ backgroundColor: `${siteConfig.colors.primary}15` }}
              >
                <MapPin className="w-5 h-5" style={{ color: siteConfig.colors.primary }} />
              </div>
              <div>
                <div className="text-xs text-gray-500 font-medium uppercase tracking-wide mb-0.5">Location</div>
                <div className="font-bold text-sm" style={{ color: siteConfig.colors.dark }}>{siteConfig.city}, {siteConfig.state}</div>
              </div>
            </div>
          </div>
        </Reveal>

        {/* Form */}
        <Reveal as="div" animation="right">
          <QuoteFormEmbed title="Request a Free Estimate" />
        </Reveal>
      </div>
    </section>
  </>
);

export default ContactPage;
